export const STATUS = {
  Pending: "Pending",
  Approved: "Approved",
  Ongoing: "Ongoing",
  Completed: "Completed"
}

// if (STATUS === STATUS.Completed) {
//   const Approve = document.getElementById("Approve");
//   Approve.disabled = false;
// }

